(function() {
    'use strict';

    angular.module('ksef')
        .controller('KsefCompanyUpdateController', KsefCompanyUpdateController);

    KsefCompanyUpdateController.$inject = [
        '$state',
        'notificationSrvc',
        'ksefCompanyDataSrvc',
        'ksefCompanyMessagesConst',
        'errorNotificationSrvc'
    ];

    function KsefCompanyUpdateController(
        $state,
        notificationSrvc,
        ksefCompanyDataSrvc,
        ksefCompanyMessagesConst,
        errorNotificationSrvc
    ) {
        var self = this;

        self.serverErrors = {
            name: [],
            nip: [],
            nonFieldErrors: []
        };

        self.companyData = {
            name: '',
            nip: ''
        };

        self.updateCompany = updateCompany;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getCompany();
        }

        function getCompany() {
            return ksefCompanyDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function(response) {
                self.companyData = response;

                delete self.companyData.date_modified;
                delete self.companyData.date_added;
                return response;
            });
        }

        function updateCompany() {
            ksefCompanyDataSrvc.update({
                pk: self.companyData.pk
            }, self.companyData).$promise.then(
                function() {
                    notificationSrvc.notification('success', ksefCompanyMessagesConst.update);
                    $state.go('layout.ksef-companies.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();

